export default __webpack_public_path__ + "static/media/Helm of the Ubah Kan.7e980df3.jpg";